export function getImportMetaEnvProp(prop: keyof ImportMetaEnv): string {
  return import.meta.env[prop] ?? '';
}
